import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import actions from 'react/api/actions/index';
import SuspenseActions from './suspenseActions';
import ChatContainer from 'react/components/Chat';

function Bottom({
  suspenseActionsIsOpen,
  miniDashboardIsOpen,
  toggleSuspenseActions,
  addNewChatWindow,
  toggleMiniDashboard
}) {
  const className = useMemo(() => {
    if (miniDashboardIsOpen) {
      return 'bottomContainer miniDashboardIsOpen';
    }

    return 'bottomContainer'
  }, [miniDashboardIsOpen]);

  function fixLeaftletMapLicencePosition() {
    const leafletBottomInfoContainer = document
      .querySelector('#RouteMonitor .leaflet-bottom.leaflet-right');

    if (!leafletBottomInfoContainer) {
      return;
    }

    if (!miniDashboardIsOpen) {
      leafletBottomInfoContainer.style.right = '88px';
    } else {
      leafletBottomInfoContainer.style.right = '0px';
    }
  }

  useEffect(() => {
    fixLeaftletMapLicencePosition();
  }, [miniDashboardIsOpen]);

  return (
    <div className={className} data-testid="bottom-container">
      <ChatContainer />
      <SuspenseActions 
        miniDashboardIsOpen={miniDashboardIsOpen}
        addNewChatWindow={addNewChatWindow} 
        suspenseActionsIsOpen={suspenseActionsIsOpen}
        toggleSuspenseActions={toggleSuspenseActions}
        toggleMiniDashboard={toggleMiniDashboard}
      />
    </div>
  );
}

Bottom.propTypes = {
  suspenseActionsIsOpen: PropTypes.bool.isRequired,
  miniDashboardIsOpen: PropTypes.bool.isRequired,
  addNewChatWindow: PropTypes.func.isRequired,
  toggleMiniDashboard: PropTypes.func.isRequired,
};

const mapStateToProps = ({ footer }) => ({
  suspenseActionsIsOpen: footer.get('suspenseActionsIsOpen'),
  miniDashboardIsOpen: footer.get('miniDashboardIsOpen'),
});

const mapDispatchToProps = {
  addNewChatWindow: actions.chat.actionCreators.addNewChatWindow,
  toggleSuspenseActions: actions.footer.actionCreators.toggleSuspenseActions,
  toggleMiniDashboard: actions.footer.actionCreators.toggleMiniDashboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(Bottom);
